import * as React from 'react';
import { DataGrid, GridToolbarColumnsButton, GridToolbarFilterButton } from '@mui/x-data-grid';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Divider } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	// Material UI dataGrid has default max row height set to 52px. to make the row height dynamic, unset max height for all elements.
	dataGrid: {
		'& .MuiDataGrid-renderingZone': {
			maxHeight: 'none !important',
		},
		'& .MuiDataGrid-cell': {
			lineHeight: 'unset !important',
			maxHeight: 'none !important',
			whiteSpace: 'normal',
			display: 'flex',
			alignItems: 'center',
			// Remove blue color border highlight when mouse is over the datagrid cell.
			outline: 'none !important',
		},
		'& .MuiGrid-item': {
			display: 'flex',
			alignItems: 'center',
		},
		backgroundColor: 'white',
	},
	gridRoot: {
		height: '800px',
	},
	accordion: {
		backgroundColor: '#F5F5F5',
	},
}));
const ResultsGridToolBar = () => {
	return (
		<>
			<GridToolbarColumnsButton />
			<GridToolbarFilterButton />
		</>
	);
};
function ResultsDataGrid({ rows, columns, handleRowClick, rowState, setRowsState, totalHits }) {
	const classes = useStyles();
	const handleCellClick = (colParams, event) => {
		// disable snapshot drawer when clicked on tags and manage cells.
		if (colParams.colDef.field === 'tags' || colParams.colDef.field === 'action') {
			event.stopPropagation();
		}
	};
	return (
		<div className={classes.gridRoot}>
			<DataGrid
				components={{
					Toolbar: ResultsGridToolBar,
				}}
				pagination
				rowCount={totalHits}
				{...rowState}
				paginationMode="server"
				className={classes.dataGrid}
				onPageChange={(page) => setRowsState((prev) => ({ ...prev, page }))}
				columns={columns}
				disableSelectionOnClick
				rowsPerPageOptions={[25, 50, 100]}
				onPageSizeChange={(pageSize) => setRowsState((prev) => ({ ...prev, pageSize }))}
				density="comfortable"
				onRowClick={handleRowClick}
				onCellClick={handleCellClick}
				disableColumnMenu
			/>
		</div>
	);
}
const AccordionSummaryTxt = ({ label, count }) => {
	return (
		<div>
			<Typography variant="h4">{label}</Typography>
			<Typography variant="body1">{`search results: ${count} item(s)`}</Typography>
		</div>
	);
};

export default function DataGridAccordion({
	rows,
	label,
	columns,
	filterComponent,
	totalHits,
	handleRowClick,
	setRowState,
	...props
}) {
	const classes = useStyles();
	const isExpanded = totalHits > 0 ? true : false;
	const [expanded, setExpanded] = React.useState(true);
	const rowState = { ...props, rows: rows };
	React.useEffect(() => {
		// collapse grid when there are no results.
		setExpanded(isExpanded);
	}, [isExpanded]);
	const handleChange = () => {
		setExpanded(!expanded);
	};
	return (
		<div>
			<Accordion className={classes.accordion} expanded={expanded} onChange={handleChange}>
				<AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="source-content" id="source-content">
					<AccordionSummaryTxt label={label} count={totalHits} />
				</AccordionSummary>
				<Divider />
				<AccordionDetails>
					<Grid container>
						<Grid item xs={12}>
							<Box pt={2} />
							{filterComponent}
						</Grid>
						<Grid item xs={12}>
							<Box pt={2} />
							<ResultsDataGrid
								rows={rows}
								columns={columns}
								handleRowClick={handleRowClick}
								rowState={rowState}
								setRowsState={setRowState}
								totalHits={totalHits}
							/>
						</Grid>
					</Grid>
				</AccordionDetails>
			</Accordion>
			<Box m={2} />
		</div>
	);
}
